export const formatAddonName = (
    name: string,
    quantity: number,
    formattedUnitPrice?: string
): string =>
    [`${quantity}× ${name}`, formattedUnitPrice ? `(${formattedUnitPrice})` : null]
        .filter(Boolean)
        .join(' ')

export const formatProductItemName = (name: string, formattedUnitPrice?: string): string =>
    [name, formattedUnitPrice ? `(${formattedUnitPrice})` : null].filter(Boolean).join(' ')
